export default __webpack_public_path__ + "static/media/pluses4.78f29ddc.png";